

import XLSX from "xlsx";
import { saveAs } from "file-saver";

const makeUrlForBlob = data => {
    var blob = new Blob([data], { type: "application/binary" });

    var fileURL = URL.createObjectURL(blob);

    return fileURL;
};

const SaveToDisk = (fileURL, fileName) => {
    // for non-IE
    if (!(window.ActiveXObject || "ActiveXObject" in window)) {
        var save = document.createElement("a");
        save.href = fileURL;
        save.target = "_blank";
        save.download = fileName || fileURL;
        var evt = document.createEvent("MouseEvents");
        evt.initMouseEvent(
            "click",
            true,
            true,
            window,
            1,
            0,
            0,
            0,
            0,
            false,
            false,
            false,
            false,
            0,
            null
        );
        save.dispatchEvent(evt);
        (window.URL || window.webkitURL).revokeObjectURL(save.href);
    }
};

const createFile = (file, target) => {
    var reader = new FileReader();
    reader.onload = e => {
        target.file = e.target.result;
    };
    reader.readAsDataURL(file);
    target.name = file.name;
    return target;
};

const excelDownload = (data, FileName, sheetName) => {
    var wb = XLSX.utils.book_new();

    var newWorksheet = excelHandler.getWorksheet(data);
    XLSX.utils.book_append_sheet(wb, newWorksheet, sheetName);

    var wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });
    saveAs(
        new Blob([s2ab(wbout)], { type: "application/octet-stream" }),
        `${FileName}.xlsx`
    );
};

var excelHandler = {
    getWorksheet: data => {
        return XLSX.utils.aoa_to_sheet(data);
    }
};

const s2ab = s => {
    var buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
    var view = new Uint8Array(buf); //create uint8array as viewer
    for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff; //convert to octet
    return buf;
};

const selectElemByKey = (inputList, keys) => {
    var pureUserList = [];
    for (var i in inputList) {
        var pureUser = {};
        for (var j in keys) {
            var dbTypedbSchemaTableKey = keys[j];
            if (inputList[i][dbTypedbSchemaTableKey] == undefined) inputList[i][dbTypedbSchemaTableKey] = "";
            pureUser[dbTypedbSchemaTableKey] = inputList[i][dbTypedbSchemaTableKey];
        }
        pureUserList.push(pureUser);
    }

    return pureUserList;
};

const convertJsonToCsv = json_array => {
    var csv_data = [];
    var header = [];

    for (var dbTypedbSchemaTableKey in json_array[0]) {
        header.push(dbTypedbSchemaTableKey);
    }
    csv_data.push(header);

    for (var i in json_array) {
        var data = [];
        for (var key2 in json_array[i]) {
            data.push(json_array[i][key2]);
        }
        csv_data.push(data);
    }

    return csv_data;
};

const getFiles = (files, comments) => {
    var rtnFiles = [];

    if (files == undefined) return;

    if (comments === undefined) {
        files.forEach(file => {
            if (file.comments === undefined || file.commnets === "") {
                rtnFiles.push(file);
            }
        });
    } else {
        files.forEach(file => {
            if (file.comments !== undefined && file.comments !== "") {
                rtnFiles.push(file);
            }
        });
    }

    return rtnFiles;
};

const MAX_UPLOAD_FILE_SIZE = 20 * 1024 * 1024;

const UPLOAD_FILE_EXTENSIONS = [
    "pdf",
    "xlsx",
    "jpg",
    "jpeg",
    "png",
    "doc",
    "docx",
    "zip"
];

const IMAGE_UPLOAD_FILE_EXTENSIONS = [
    "jpeg",
    "jpg",
    "png",
    "zip"
];

const getFileExtension = (fileName = "") => {
    const normalizedName = String(fileName).trim().toLowerCase();
    const lastDotIndex = normalizedName.lastIndexOf(".");

    if (lastDotIndex < 0) return "";

    return normalizedName.slice(lastDotIndex + 1);
};

const validateUploadFiles = (files = []) => {
    const fileList = Array.from(files || []);
    const uploadExtensions = new Set(UPLOAD_FILE_EXTENSIONS);
    const totalFileSize = fileList.reduce((sum, file) => sum + file.size, 0);

    if (totalFileSize > MAX_UPLOAD_FILE_SIZE) {
        return {
            isValid: false,
            message: "첨부파일 전체 용량은 20MB를 초과할 수 없습니다.",
        };
    }

    for (const file of fileList) {
        if (file.size > MAX_UPLOAD_FILE_SIZE) {
            return {
                isValid: false,
                message: `${file.name} 파일은 20MB를 초과할 수 없습니다.`,
            };
        }

        const extension = getFileExtension(file.name);
        if (!uploadExtensions.has(extension)) {
            return {
                isValid: false,
                message: `${file.name} 파일은 업로드할 수 없는 확장자입니다.`,
            };
        }
    }

    return { isValid: true, files: fileList };
};

const validateImageUploadFiles = (files = []) => {
    const uploadValidation = validateUploadFiles(files);

    if (!uploadValidation.isValid) return uploadValidation;

    const imageExtensions = new Set(IMAGE_UPLOAD_FILE_EXTENSIONS);

    for (const file of uploadValidation.files) {
        const extension = getFileExtension(file.name);
        if (!imageExtensions.has(extension)) {
            return {
                isValid: false,
                message: `jpg, jpeg, png, zip 파일만 업로드할 수 있습니다.`,
            };
        }
    }

    return uploadValidation;
};

export {
    makeUrlForBlob,
    SaveToDisk,
    createFile,
    excelDownload,
    selectElemByKey,
    convertJsonToCsv,
    getFiles,
    MAX_UPLOAD_FILE_SIZE,
    UPLOAD_FILE_EXTENSIONS,
    IMAGE_UPLOAD_FILE_EXTENSIONS,
    validateUploadFiles,
    validateImageUploadFiles
};


